"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const meSettingsNotifyMutation = (0, graphql_tag_1.default)`
  mutation me_settings_notify(
    $allowTelegramMessage: Boolean
    $allowsCommonNotifications: Boolean
    $allowsPrivateNotifications: Boolean
    $allowsPushNotifications: Boolean
    $markAsNotSpammers: Boolean
  ) {
    me {
      settings {
        notify(
          allowTelegramMessage: $allowTelegramMessage
          allowsCommonNotifications: $allowsCommonNotifications
          allowsPrivateNotifications: $allowsPrivateNotifications
          allowsPushNotifications: $allowsPushNotifications
          markAsNotSpammers: $markAsNotSpammers
        ) {
          status
        }
      }
    }
  }
`;
exports.default = meSettingsNotifyMutation;